import React from 'react';

const Footer = () => {
  return <div className='row'>
    <div className='col'>
      <div className={'row footer nospace'}>
        <div className='info col'>
          <div className='row align-items-center'>
            <div className='col-12 col-lg-5 offset-lg-1 col-xxl-4 offset-xxl-2'>
              <div className='logo'></div>
            </div>
            <div className='col-12 col-lg-5 col-xxl-4'>
              <div className='row'>
                <div className='col-12'>
                  <div className="links">
                    <div className='link'>
                      <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy policy</a>
                    </div>
                    <div className='link'>
                      <a href='/terms-and-conditions' target='_blank' rel='noopener noreferrer'>Termini e condizioni</a>
                    </div>
                    <div className='link'>
                      <a href='https://dufercoenergia.com/' target='_blank' rel='noopener noreferrer'>dufercoenergia.com</a>
                    </div>
                  </div>
                  <div className='copyright'>
                    © {new Date().getFullYear()} Duferco Energia All rights reserved.<br />Powered By Duferco Dev
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
};

export default Footer;
